// extracted by extract-css-chunks-webpack-plugin
module.exports = {"containerText":"_2HX1Ya","fullWidthText":"_3zhlE0"};